import { Theme } from './app.state';

const ACTION_SCOPE = '[App]';

const createType = (_class: { name: string}): string => {
  return `[${ACTION_SCOPE}] ${_class.name}`;
}

export class SetTheme {
  static readonly type = createType(this);
  constructor(public theme: Theme) {}
}